export const SCROLLDOWN_ANIMATED_MODEL = {
  product: "Seguro Vida Devolución Garantizada",
  rangeScrollDesktop: 550,
  rangeScrollMobile: 650,
};

export const AUDITORY_MODEL = {
  paso: 0,
  pasoDescripcion: "PASO_INICIAL",
};

export const WHATSAPP_MODEL = {
  active: true,
  activeMobile: true,
  label: "Compra por WhatsApp",
  iconSrc:
    "/ventadigital/devolucion/assets/rebrand/home/hero/gl-whatsapp-solid.svg",
  link: "https://wa.link/bveb44",
};

export const BANNER_CYBER_MODEL = {
  srcImgCyber:
    "https://imagescdn.rimac.com/bltb8ad0bee8dde6050/654aadfe7cdbb0040a13dc26/logo-cyber-rimac.svg",
  formatTillDate: "11/13/2023",
  text: "¡No dejes pasar nuestras promos!",
  textMobile: "Participa por un viaje a Punta Cana",
  resetEveryDay: false,
};

export const HERO_MODEL = {
  title: "Seguro vida ahorro con devolución",
  titleUni: "Seguro universitario",
  titleMobile: "Vida ahorro con devolución",
  titleMobileUni: "Seguro universitario",
  subtitle: "Ahorra para tus metas desde S/18.50",
  subtitleUni: "Recupera hasta el 200% de tus aportes",
  description: "Ingresa tus datos y conoce tu ganancia",
  descriptionUni:
    "Prepara a tus hijos para el éxito con un ahorro para su educación y futuro.",

  titleCyber: "¡Inició el Cyber! Aprovecha desde S/18.50 al mes",
  heroCyberDesktop:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-desktop-cyber.png",
  heroCyberDesktopWebp:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-desktop-cyber.webp",
  heroCyberMobile:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-mobile-cyber.png",
  heroCyberMobileWebp:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-mobile-cyber.webp",
  heroUniCyberMobile:
    "https://imagescdn.rimac.com/blt1ca584dfb4d9dd0e/67dc3da2443bd6ca82f1bd14/cyber-universitario-mobile.png",
  heroUniCyberMobileWebp:
    "https://imagescdn.rimac.com/blte0ea3a181a6cffdd/67dc3daedb243f2d3812b614/cyber-universitario-mobile.webp",
  heroUniCyberDesktop:
    "https://imagescdn.rimac.com/bltf3162d6c4e6a0c8d/67db42989c716d850910d0d3/cyber-universitario-desktop.png",
  heroUniCyberDesktopWebp:
    "https://imagescdn.rimac.com/blt03f298151b3a24c3/67db4298db833b09d65550e2/cyber-universitario-desktop.webp",
  heroTravelCyberMobile:
    "https://imagescdn.rimac.com/blt1608305f439f1b46/67db50c92476a95bda7d9457/cyber-viajes-mobile.png",
  heroTravelCyberMobileWebp:
    "https://imagescdn.rimac.com/blt191c96dcf593857d/67db50c9a4b93f0c050a0af0/cyber-viajes-mobile.webp",
  heroTravelCyberDesktop:
    "https://imagescdn.rimac.com/blt402f910f538b502c/67db444ba5c04320b6717ef7/cyber-viajes-desktop.png",
  heroTravelCyberDesktopWebp:
    "https://imagescdn.rimac.com/blt6c269025c83b6093/67db444bfe8d6a604848db2f/cyber-viajes-desktop.webp",
  heroMob:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-mobile.png",
  heroUniMob:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-universitario-mobile.png",
  heroDesktop:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-desktop.png",
  heroUniDesktop:
    "/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-universitario-desktop.png",
  iconKnowMore:
    "/ventadigital/devolucion/assets/rebrand/home/hero/icon-know-more.svg",
  textKnowMore: "Conoce más",
  mayor64Step: "/comprar/seguro-vida-devolucion-garantizada/gracias-edad",
  notFoundStep: "/comprar/seguro-vida-devolucion-garantizada/datos-personales",
  nClientStep: "/comprar/seguro-vida-devolucion-garantizada/gracias-ncliente",
  errorStep: "/comprar/seguro-vida-devolucion-garantizada/error",
  graciasDatos: "/comprar/seguro-vida-devolucion-garantizada/datos-personales",
  errorValidacionStep:
    "/comprar/seguro-vida-devolucion-garantizada/error-validacion",
  origenApp: "app",
  urlPrivacidad: "https://www.rimac.com/politica-privacidad",
  edadMenor: "18",
  edadMayor: "64",
  nextStep: "/comprar/seguro-vida-devolucion-garantizada/cotizacion",
  graciasValidacionStep:
    "/comprar/seguro-vida-devolucion-garantizada/gracias-validacion",
  pathCe: "/comprar/seguro-vida-devolucion-garantizada/gracias-extranjeria",
  btnText: "Simular ganancia",
};

export const BENEFITS_MODEL = {
  title: "Beneficios de tu Seguro de Vida Ahorro con Devolución",
  benefits: [
    {
      benefit: "Baño para  tu mascota",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-mascota-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-mascota-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-mascota-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-mascota-desktop.webp",
      type: 1,
      discountText: "S/ 15",
      discountReason: "",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Médico a domicilio",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-medico-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-medico-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-medico-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-medico-desktop.webp",
      type: 1,
      discountText: "S/ 30",
      discountReason: "",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Chequeo preventivo",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-chequeo-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-chequeo-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-chequeo-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-chequeo-desktop.webp",
      type: 1,
      discountText: "",
      discountReason: "Sin costo",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "1 vez al año",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Orientación médica telefónica",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-orientacion-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-orientacion-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-orientacion-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-orientacion-desktop.webp",
      type: 1,
      discountText: "",
      discountReason: "Sin costo",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Star Perú",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-star-peru-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-star-peru-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-star-peru-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-star-peru-desktop.webp",
      type: 2,
      discountText: "40%",
      discountReason: "dscto.",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "LG",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-lg-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-lg-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-lg-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-lg-desktop.webp",
      type: 2,
      primaryText: "Hasta",
      discountText: "45%",
      discountReason: "dscto.",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Garmin",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-garmin-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-garmin-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-garmin-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-garmin-desktop.webp",
      type: 2,
      primaryText: "Hasta",
      discountText: "S/450",
      discountReason: "dscto.",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
    {
      benefit: "Coney Park",
      imageMobile:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-coney-park-mobile.png",
      imageMobileWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-coney-park-mobile.webp",
      imageDesktop:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-coney-park-desktop.png",
      imageDesktopWebp:
        "/ventadigital/devolucion/assets/vida-devolucion/home/benefits/beneficio-coney-park-desktop.webp",
      type: 2,
      primaryText: "",
      discountText: "50%",
      discountReason: "dscto.",
      items: [
        {
          icon: "RideGlStarSolid",
          name: "Uso ilimitado",
        },
        {
          icon: "RideGlPinSolid",
          name: "Lima y provincias",
        },
      ],
    },
  ],
};

export const PLAN_SECTION_MODEL = {
  title: "Así funciona el Seguro de Vida Ahorro con Devolución",
  universityTitle: "Un seguro pensado en ti",
  image:
    "/ventadigital/devolucion/assets/vida-devolucion/home/plans/beneficios-dk.png",
  universityImage:
    "/ventadigital/devolucion/assets/vida-devolucion/home/plans/img-uni-benefits-desktop.png",
  benefits: [
    {
      title: "Mariana ahorra S/159 mensuales",
      description: "<p>Para poder juntar la inicial de su departamento</p>",
    },
    {
      title: "En caso le pase algo, sus seres queridos recibirán S/50,000",
    },
    {
      title: "Al pasar 9 años recibirá S/23,326",
      description:
        "<p>Es así, como habrá <b>ganado S/6,047</b> lo que representa un 135% de devolución.</p>",
    },
  ],
  universityBenefits: [
    {
      title: "Hoy",
      description:
        "<p>Julia quiere empezar a ahorrar para la educación de su hija. Descubrió el Seguro Universitario y decidió ahorrar para el colegio.</p>",
    },
    {
      title: "Luego de adquirir el seguro",
      description:
        "<p>Julia está feliz y tranquila porque sabe que su hija está protegida y que en 5 años podrá recibir una ganancia sobre los ahorros.</p>",
    },
    {
      title: "5 años después",
      description:
        "<p>Julia retira sus ahorro y paga la cuota inicial del colegio de su primera hija. Se siente tranquila porque valió la pena haber ahorrado.</p>",
    },
  ],
};

export const WHY_ACQUIRE_MODEL = {
  title: "¿Por qué adquirir un Seguro Universitario?",
  reasons: [
    {
      title: "Inversión a tu alcance",
      icon: "RideIcWalletLight",
      list: [
        "Planifica un mejor futuro para tus hijos ahorrando un monto fijo a corto plazo.",
        "Puedes solicitar el retorno de tu inversión antes del plazo final.",
      ],
    },
    {
      title: "Te cuidamos siempre",
      icon: "RideIcProtectionLight",
      list: [
        "La educación de tu hijo asegurado estará protegida aún en caso de que faltes.",
      ],
    },
    {
      title: "Facilidad de pago",
      icon: "RideIcCoinLight",
      list: [
        "Pagos flexibles para tu tranquilidad y de los que más quieres.",
        "Obtén descuentos por pagar anualmente.",
      ],
    },
  ],
};

export const QUESTION_MODEL = {
  title:
    "¿Dudas sobre tu Seguro de Vida Ahorro con Devolución? <strong>¡Las resolvemos!</strong>",
  universityTitle: "¿Tienes dudas? ¡Las resolvemos!",
  linkTerms: "https://www.rimac.com/terminos-y-condiciones",
  textTerms: "Todas nuestras promociones están sujetas a",
  textLinkTerms: "términos y condiciones.",
  questions: [
    {
      question: "¿Qué es un Seguro de Vida Ahorro con Devolución?",
      answer:
        "Es un seguro de vida con inversión, en el puedes recibir hasta el 200% de tus aportes invirtiendo desde S/18.50 al mes, mientras proteges a tu familia en caso de fallecimiento. ¡Tú puedes cumplir tus metas!",
      icon: "RideGlLifeInvestmentSolid",
      textLink: "Descargar toda las exclusiones",
      pdfUrl:
        "/ventadigital/devolucion/assets/rebrand/home/questions/Exclusiones_Seguro_Vida_Ahorro_con_Devolución.pdf",
      linkingKeyword: "lifeInsurance",
    },
    {
      question: "¿Qué no cubre tu Seguro Vida Ahorro con Devolución?",
      answer: `
                Conoce algunas exclusiones:
                <ul>
                    <li>Si el asegurado se desempeña en oficios notoriamente peligrosos como miembro de fuerzas armadas y policiales, personal de seguridad, salvavidas, entre otros.</li>
                    <li>Si el asegurado tiene una enfermedad, condición o lesión preexistente.</li>
                    <li>Si el asegurado se accidenta en estado de ebriedad o bajo el efecto de drogas.</li>
                </ul>
            `,
      icon: "RideGlCoverageSolid",
    },
    {
      question: "¿Puedes retirar tu dinero antes del tiempo elegido?",
      answer:
        "En caso de que ocurra algún imprevisto en el plazo acordado, tendrás la opción de solicitar un retiro anticipado. El valor final que recibirás dependerá de la fecha en que realices la solicitud y de los pagos realizados hasta ese momento.",
      icon: "RideGlPremiumHealthSolid",
    },
    {
      question: "¿La devolución de todos tus aportes está garantizada?",
      answer:
        "Sí, siempre y cuando se complete el plazo establecido en la póliza, se realizará el depósito correspondiente por el valor total de tus aportes y la ganancia obtenida.",
      icon: "RideGlMoneySolid",
    },
    {
      question: "¿Cuánto puedo recibir de devolución?",
      answer:
        "Depende de cuánto y por cuánto tiempo ahorres. En el ejemplo de Mariana, CON s/159 AL MES DURANTE 9 AÑOS RECIBIÓ s/23,326. Puedes simular tu caso con tu documento y celular.",
      icon: "RideGlDollarSolid",
    },
    {
      question: "¿Desde cuánto puedo empezar a ahorrar?",
      answer:
        "Desde S/18.50 al mes. El monto y el plazo se ajustan a tu meta de ahorro.",
      icon: "RideGlProcessSolid",
    },
    {
      question: "¿Qué beneficios de salud incluye?",
      answer:
        "Médico a domicilio (S/30), baño para tu mascota (S/15), chequeo preventivo anual sin costo y orientación médica telefónica ilimitada, en Lima y provincias.",
      icon: "RideGlInsuranceSolid",
    },
    {
      question: "¿Para quién es este seguro?",
      answer:
        "Para quienes quieren cumplir una meta de ahorro (inicial de una casa, educación, viajes, etc...) y a la vez proteger económicamente a su familia.",
      icon: "RideGlHeartSolid",
    },
  ],
  universityQuestions: [
    {
      question: "¿Qué es un Seguro Universitario?",
      answer:
        "Es un fondo que te permite ahorrar para garantizar la educación universitaria de tus hijos mediante un ahorro programado, y al mismo tiempo, te ofrece protección financiera. En caso de fallecimiento o invalidez, cubrimos los costos educativos de tus hijos.",
      icon: "RideGlLifeInvestmentSolid",
      textLink: "Descargar toda las exclusiones",
      pdfUrl:
        "/ventadigital/devolucion/assets/rebrand/home/questions/Exclusiones_Seguro_Vida_Ahorro_con_Devolución.pdf",
      linkingKeyword: "lifeInsurance",
    },
    {
      question: "¿Qué no cubre tu Seguro Universitario?",
      answer: `
                Conoce algunas exclusiones:
                <ul>
                    <li>Si el asegurado se desempeña en oficios notoriamente peligrosos como miembro de fuerzas armadas y policiales, personal de seguridad, salvavidas, entre otros.</li>
                    <li>Si el asegurado tiene una enfermedad, condición o lesión preexistente.</li>
                    <li>Si el asegurado se accidenta en estado de ebriedad o bajo el efecto de drogas.</li>
                </ul>
            `,
      icon: "RideGlCoverageSolid",
    },
    {
      question: "¿Puedes retirar tu dinero antes del tiempo elegido?",
      answer:
        "En caso de que ocurra algún imprevisto en el plazo acordado, tendrás la opción de solicitar un retiro anticipado. El valor final que recibirás dependerá de la fecha en que realices la solicitud y de los pagos realizados hasta ese momento.",
      icon: "RideGlPremiumHealthSolid",
    },
    {
      question: "¿La devolución de todos tus aportes está garantizada?",
      answer:
        "Sí, siempre y cuando se complete el plazo establecido en la póliza, se realizará el depósito correspondiente por el valor total de tus aportes y la ganancia obtenida.",
      icon: "RideGlMoneySolid",
    },
    {
      question: "¿Cómo funciona el seguro universitario?",
      answer:
        "Eliges un monto y plazo fijo para ahorrar; al completarlo, recibes de vuelta tus aportes más una ganancia (devolución garantizada). Si necesitas el dinero antes, puedes pedir un retiro anticipado, aunque el monto final dependerá de la fecha y de los pagos hechos hasta ese momento.",
      icon: "RideGlCoverageSolid",
    },
    {
      question: "¿Cuánto cuesta un seguro universitario?",
      answer:
        "El costo depende del monto que quieras ahorrar y el plazo elegido, y ofrece pagos flexibles con descuento si pagas anualmente. Para saber el costo exacto déjanos tus datos y nos contactaremos contigo.",
      icon: "RideGlCoverageSolid",
    },
  ],
};

export const FOOTER_MODEL = {
  logoDesktop:
    "/ventadigital/devolucion/assets/rebrand/home/footer-rebrand-vertical.svg",
  logoMobile:
    "/ventadigital/devolucion/assets/rebrand/home/footer-rebrand-horizontal.svg",
  address: "Calle Las Begonias 650 Piso 10, San Isidro.",
  altFooter: "Logo Footer",
};

export const SCHEMA_HERO_MODEL = {
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "Seguro Vida Ahorro con Devolución",
  "image": "https://www.rimac.com/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-desktop.webp",
  "brand": {
    "@type": "Brand",
    "name": "Rimac Seguros"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "155"
  },
  "offers": {
    "@type": "AggregateOffer",
    "url": "https://www.rimac.com/comprar/seguro-vida-devolucion-garantizada",
    "priceCurrency": "PEN",
    "lowPrice": "159"
  }
}

export const SCHEMA_HERO_UNIVERSITARIO_JSONLD = {
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "Seguro Universitario",
  "image": "https://www.rimac.com/ventadigital/devolucion/assets/vida-devolucion/home/hero/hero-universitario-desktop.webp",
  "brand": {
    "@type": "Brand",
    "name": "Rimac Seguros"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "130"
  },
  "offers": {
    "@type": "AggregateOffer",
    "url": "https://www.rimac.com/comprar/seguro-vida-devolucion-garantizada?version=universitario&pcid=publica:producto-seguro-universitario:cotizar-seguro-universitario:header:button",
    "priceCurrency": "PEN",
    "lowPrice": "18.50"
  }
};

export const SCHEMA_QUESTION_MODEL = {
  question: [
    {
      name: "¿Qué es un Seguro de Vida Ahorro con Devolución?",
      text:
        "Es un seguro de vida con inversión, en el que puedes recibir hasta el 200% de tus aportes invirtiendo desde S/18.50 al mes, mientras proteges a tu familia en caso de fallecimiento. ¡Tú puedes cumplir tus metas!",
    },
    {
      name: "¿Qué no cubre tu Seguro Vida Ahorro con Devolución?",
      text:
        "Conoce algunas exclusiones: Si el asegurado se desempeña en oficios notoriamente peligrosos como miembro de fuerzas armadas y policiales, personal de seguridad, salvavidas, entre otros. Si el asegurado tiene una enfermedad, condición o lesión preexistente. Si el asegurado se accidenta en estado de ebriedad o bajo el efecto de drogas.",
    },
    {
      name: "¿Puedes retirar tu dinero antes del tiempo elegido?",
      text:
        "En caso de que ocurra algún imprevisto en el plazo acordado, tendrás la opción de solicitar un retiro anticipado. El valor final que recibirás dependerá de la fecha en que realices la solicitud y de los pagos realizados hasta ese momento.",
    },
    {
      name: "¿La devolución de todos tus aportes está garantizada?",
      text:
        "Sí, siempre y cuando se complete el plazo establecido en la póliza, se realizará el depósito correspondiente por el valor total de tus aportes y la ganancia obtenida.",
    },
    {
      name: "¿Cuánto puedo recibir de devolución?",
      text:
        "Depende de cuánto y por cuánto tiempo ahorres. En el ejemplo de Mariana, con S/159 al mes durante 9 años recibió S/23,326. Puedes simular tu caso con tu documento y celular.",
    },
    {
      name: "¿Desde cuánto puedo empezar a ahorrar?",
      text:
        "Desde S/18.50 al mes. El monto y el plazo se ajustan a tu meta de ahorro.",
    },
    {
      name: "¿Qué beneficios de salud incluye?",
      text:
        "Médico a domicilio (S/30), baño para tu mascota (S/15), chequeo preventivo anual sin costo y orientación médica telefónica ilimitada, en Lima y provincias.",
    },
    {
      name: "¿Para quién es este seguro?",
      text:
        "Para quienes quieren cumplir una meta de ahorro (inicial de una casa, educación, viajes, etc.) y a la vez proteger económicamente a su familia.",
    },
  ],
};

export const SCHEMA_QUESTION_UNIVERSITARIO_MODEL = {
  question: [
    {
      name: "¿Qué es un Seguro Universitario?",
      text:
        "Es un fondo que te permite ahorrar para garantizar la educación universitaria de tus hijos mediante un ahorro programado, y al mismo tiempo, te ofrece protección financiera. En caso de fallecimiento o invalidez, cubrimos los costos educativos de tus hijos.",
    },
    {
      name: "¿Qué no cubre tu Seguro Universitario?",
      text:
        "Conoce algunas exclusiones: Si el asegurado se desempeña en oficios notoriamente peligrosos como miembro de fuerzas armadas y policiales, personal de seguridad, salvavidas, entre otros. Si el asegurado tiene una enfermedad, condición o lesión preexistente. Si el asegurado se accidenta en estado de ebriedad o bajo el efecto de drogas.",
    },
    {
      name: "¿Puedes retirar tu dinero antes del tiempo elegido?",
      text:
        "En caso de que ocurra algún imprevisto en el plazo acordado, tendrás la opción de solicitar un retiro anticipado. El valor final que recibirás dependerá de la fecha en que realices la solicitud y de los pagos realizados hasta ese momento.",
    },
    {
      name: "¿La devolución de todos tus aportes está garantizada?",
      text:
        "Sí, siempre y cuando se complete el plazo establecido en la póliza, se realizará el depósito correspondiente por el valor total de tus aportes y la ganancia obtenida.",
    },
    {
      name: "¿Cómo funciona el seguro universitario?",
      text:
        "Eliges un monto y plazo fijo para ahorrar; al completarlo, recibes de vuelta tus aportes más una ganancia (devolución garantizada). Si necesitas el dinero antes, puedes pedir un retiro anticipado, aunque el monto final dependerá de la fecha y de los pagos hechos hasta ese momento.",
    },
    {
      name: "¿Cuánto cuesta un seguro universitario?",
      text:
        "El costo depende del monto que quieras ahorrar y el plazo elegido, y ofrece pagos flexibles con descuento si pagas anualmente. Para saber el costo exacto déjanos tus datos y nos contactaremos contigo.",
    },
  ],
};

export const CYBER_CONTENT_BANNER = [
    {
      venta_digital_cintillo: {
        type: "cyber",
        subtype: "cyber_counter",
        text: {
          main: "¡Participa por un bloqueador La Roche-Posay!",
        },
        time: {
          start_date: "",
          final_date: "",
        },
        image_png: {
          image_mobile: { url: BANNER_CYBER_MODEL.srcImgCyber },
          image_desktop: { url: BANNER_CYBER_MODEL.srcImgCyber },
        },
        image_webp: {
          image_mobile: { url: BANNER_CYBER_MODEL.srcImgCyber },
          image_desktop: { url: BANNER_CYBER_MODEL.srcImgCyber },
        },
        active_counter: true,
        reset_days: 0,
        name_product: "Cyber Days Julio",
        banner_with_redirection: {
          active_go_icon_button: false,
          url: "",
        },
      },
    },
  ];
